import { render, staticRenderFns } from "./depot.vue?vue&type=template&id=00702570&scoped=true&"
import script from "./depot.vue?vue&type=script&lang=js&"
export * from "./depot.vue?vue&type=script&lang=js&"
import style0 from "./depot.vue?vue&type=style&index=0&id=00702570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00702570",
  null
  
)

component.options.__file = "depot.vue"
export default component.exports